import script from "./PasesContratados.vue?vue&type=script&setup=true&lang=js"
export * from "./PasesContratados.vue?vue&type=script&setup=true&lang=js"

import "./PasesContratados.vue?vue&type=style&index=0&id=2005324e&scoped=true&lang=css"

import exportComponent from "/var/www/pases-h2o/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2005324e"]])

export default __exports__